export default __webpack_public_path__ + "static/media/bottom.8e7048ef.svg";